<template>
  <div class="ddSms">
    <div class="popup_toals">
      共 <b>{{ total }}</b> 条数据
    </div>
    <el-table
      ref="multipleTable"
      :data="tableSmsList"
      tooltip-effect="dark"
      style="width: 100%"
      :header-cell-style="{ background: '#fafafa' }"
      height="300"
    >
      <el-table-column
        align="center"
        prop="entName"
        label="发送企业"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <div>{{ scope.row.robotName }}</div>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="staffName" label="接收人">
        <template slot-scope="scope">
          <div>{{ newChannel[scope.row.smsType] }}</div>
        </template>
      </el-table-column>
    </el-table>
    <div class="table-page">
      <el-pagination
        background
        layout="total,prev, pager, next, sizes, jumper"
        :current-page.sync="pageNum"
        @size-change="handleSizeChanges"
        @current-change="handleCurrentChanges"
        :page-size="pageSize"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import { getDingTalkRecordByPage } from '@api/corporateInteraction/examine'
export default {
  name: 'DdSms',
  data() {
    return {
      total: 0,
      tableSmsList: [],
      pageNum: 1,
      pageSize: 10,
      newChannel: {
        0: '手机短信',
        1: '微信公众号',
        2: '站内消息',
        3: '浙政钉消息',
        4: '浙里办消息',
        5: '钉钉群消息'
      }
    }
  },
  mounted() {
    this.getDdSmsList()
  },
  props: {
    channelId: {
      type: Number,
      default: null
    }
  },
  methods: {
    getDdSmsList() {
      let params = {
        smsContentId: this.channelId,
        pageSize: this.pageSize,
        pageNum: this.pageNum
      }
      getDingTalkRecordByPage(params).then((res) => {
        if (res.data.code == '0000') {
          this.tableSmsList = res.data.data.results
          this.total = res.data.data.totalRecord
        }
      })
    },
    handleCurrentChanges(val) {
      this.pageNum = val
      this.getDdSmsList()
    },
    handleSizeChanges(val) {
      this.pageSize = val
      this.getDdSmsList()
    }
  }
}
</script>

<style lang="scss" scoped>
.ddSms {
  .popup_toals {
    display: flex;
    justify-content: end;
    font-size: 14px;
    margin: 0 10px 10px;
    b {
      font-size: 15px;
      color: #0099ff;
    }
  }
}
</style>
